/* eslint new-cap: ["error", { "capIsNew": false }]*/
import { fromJS, Map } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';
import { saveFinished, saveInAction } from '../../store/allaround.store';


const setCurrencies = (state, data) => state.set(data.base, fromJS(data));

export const currenciesReducer = (state = new Map(), action) => {
  switch (action.type) {
    case 'CURRENCIES_LOADED':
      return setCurrencies(state, action.data);
    case 'CURRENCY_STATES_LOADED':
      return state.set('states', fromJS(action.data).map(cs => {
        if (cs.get('currency') === 'USD') {
          return cs.set('state', true);
        }
        return cs;
      }));
    case 'CURRENCY_TOGGLED':
      return state.set('states', state.get('states').map(currencyState => {
        if (currencyState.get('currency') === action.currency) {
          return currencyState.set('state', !currencyState.get('state'));
        }
        return currencyState;
      }));
    default:
      return state;
  }
};

export const loadStates = (dispatch) => {
  dispatch({ type: 'CURRENCY_STATES_LOADING_STARTED' });
  return RestAPI.get('/currencystate/api/states')
    .then(
      (data) => {
        dispatch({ type: 'CURRENCY_STATES_LOADED', data });
        return true;
      }
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'CURRENCY_STATES_LOADING_FAILED' });
        return true;
      }
    );
};

export const toggle = (dispatch, currency) => {
  saveInAction(dispatch);
  dispatch({ type: 'CURRENCY_TOGGLE_STARTED' });
  return RestAPI.put(`/currencystate/api/${currency}/toggle`)
    .then(
      () => {
        saveFinished(dispatch);
        dispatch({ type: 'CURRENCY_TOGGLED', currency });
        return true;
      }
    ).catch(
      (data) => {
        saveFinished(dispatch);
        putError(dispatch, data);
        dispatch({ type: 'CURRENCY_TOGGLE_FAILED' });
        return true;
      }
    );
};


export const loadCurrencies = (dispatch) => {
  dispatch({ type: 'LOADING_CURRENCIES' });
  return RestAPI.get('/references/currency/api/today')
    .then(
      (data) => {
        dispatch({ type: 'CURRENCIES_LOADED', data });
        return true;
      }
    ).catch(
      (data) => {
        putError(dispatch, data);
        dispatch({ type: 'CURRENCIES_LOAD_FAILED' });
        return true;
      }
    );
};
